import { Serializer } from 'survey-core';

/**
 * Registers RNG custom SurveyJS properties used in form JSON (e.g. event participate form).
 * Must run before Survey Creator / SurveyModel loads JSON so visibilityDataSource is not rejected.
 */
export function registerRngSurveyVisibilityDataSourceProperties(dataSourceChoices?: string[]): void {
  if (!Serializer.findProperty('page', 'visibilityDataSource')) {
    Serializer.addProperty('page', {
      name: 'visibilityDataSource',
      displayName: 'Visibility Data Source',
      type: 'string',
      category: 'RNG Settings',
      visibleIndex: 5,
      choices: dataSourceChoices ?? [],
      default: ''
    });
  }
  if (!Serializer.findProperty('question', 'visibilityDataSource')) {
    Serializer.addProperty('question', {
      name: 'visibilityDataSource',
      displayName: 'Visibility Data Source',
      type: 'string',
      category: 'RNG Settings',
      visibleIndex: 4,
      choices: dataSourceChoices ?? [],
      default: ''
    });
  }
}
